export const CLIENT_TOUR_STEPS = [
  {
    target: ".tour-client-projects-table",
    title: "Projetos do Cliente",
    content:
      "Aqui encontra os projetos em gestão pela STREAM. Ao clicar numa linha, abre o detalhe do projeto.",
    placement: "bottom",
    disableBeacon: true,
  },
  {
    target: ".tour-client-employees-btn",
    title: "Funcionários",
    content:
      "Neste botão consulta os funcionários já registados na plataforma para este cliente. Esta área é apenas de leitura.",
    placement: "bottom",
  },
  {
    target: ".tour-client-projects-table",
    title: "Próximo Passo",
    content:
      "Para o tutorial completo dentro do projeto, abra um projeto da lista e clique novamente em Tutorial.",
    placement: "top",
  },
];

const PROJECT_TOUR_STEPS_BY_TAB = {
  activities: (isTheoretical) => [
    {
      target: ".tour-project-tab-activities",
      title: "Tab Atividades",
      content: isTheoretical
        ? "Esta tab é apenas de leitura. Este projeto está em fase Teórica, por isso só mostra as colunas \"Previsto\" — ainda não há execução Real distinta do planeamento. Para alterações de cronograma, deve contactar o gestor responsável do projeto."
        : "Esta tab é apenas de leitura. Para alterações de cronograma, deve contactar o gestor responsável do projeto.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".tour-project-activities-dates",
      title: "Datas do Projeto",
      content:
        "Aqui consulta as datas de início, conclusão e execução do projeto.",
      placement: "bottom",
    },
    {
      target: ".tour-project-activities-first-table",
      title: "Tabela de Atividades",
      content: isTheoretical
        ? "Nesta primeira tabela consulta os workpackages e atividades com TRL e respetivas datas previstas. As colunas \"Real\" só aparecem quando o projeto deixar a fase Teórica."
        : "Nesta primeira tabela consulta os workpackages e atividades com TRL e respetivas datas, tanto previstas como reais.",
      placement: "top",
    },
    {
      target: ".tour-project-gantt",
      title: "Cronograma",
      content:
        "Aqui visualiza o cronograma completo do projeto de forma gráfica.",
      placement: "bottom",
    },
    {
      target: ".tour-client-project-details-btn",
      title: "Detalhe do Projeto",
      content:
        "Use este botão para consultar entidade responsável, taxas e restantes detalhes do projeto.",
      placement: "bottom",
    },
  ],
  team: [
    {
      target: ".tour-project-tab-team",
      title: "Tab Equipa",
      content:
        "Esta tab é apenas de leitura e mostra os funcionários alocados ao projeto.",
      placement: "bottom",
    },
    {
      target: ".tour-project-team-table",
      title: "Tabela da Equipa",
      content:
        "Aqui consulta funcionário, perfil e período de alocação ao projeto.",
      placement: "top",
    },
  ],
  salaries: [
    {
      target: ".tour-project-tab-salaries",
      title: "Tab Salários",
      content:
        "Aqui consulta e propõe a evolução do salário e da taxa de SS de cada colaborador do projeto.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".tour-salaries-grid",
      title: "Estrutura da Grelha",
      content:
        "Cada colaborador ocupa duas linhas: a de cima mostra o período de cada intervalo e a de baixo os valores desse intervalo (salário e SS). Pode haver vários intervalos por colaborador, cada um com as suas datas.",
      placement: "top",
    },
    {
      target: ".tour-salaries-period-cell",
      title: "Período",
      content:
        "Esta linha indica o período a que se aplicam os valores logo abaixo (por exemplo, 2026-01 a 2026-12). Clique no período do último intervalo para ver ou alterar as suas datas.",
      placement: "bottom",
    },
    {
      target: ".tour-salaries-salary-cell",
      title: "Salário",
      content:
        "Aqui imputa o salário (em €) aplicável a este intervalo. Escreva o novo valor na célula. Se alterar um intervalo que não seja o último, o valor aplica-se também aos intervalos seguintes.",
      placement: "bottom",
    },
    {
      target: ".tour-salaries-ss-cell",
      title: "Taxa de SS",
      content:
        "Aqui imputa a taxa de Segurança Social (em %). Escreva a percentagem diretamente: por exemplo, 23,75 corresponde a 23,75%.",
      placement: "bottom",
    },
    {
      target: ".tour-salaries-new-interval",
      title: "Dividir ou Alterar Períodos",
      content:
        "Para aplicar um novo salário a partir de um mês, clique em \"Introduzir novo intervalo\" (ou no período do último intervalo). Escolha o mês de início — e, se quiser, o de fim — e confirme: o intervalo é dividido e pode definir o novo valor no intervalo criado.",
      placement: "bottom",
    },
    {
      target: ".tour-salaries-grid",
      title: "Células Bloqueadas e Destacadas",
      content:
        "Células a cinzento escuro estão bloqueadas: correspondem a meses já executados e não podem ser alteradas. Células destacadas a laranja são alterações suas ainda pendentes de validação interna.",
      placement: "top",
    },
    {
      target: ".tour-client-save-btn",
      title: "Guardar e Validação",
      content:
        "Carregue em Guardar para enviar as alterações. Elas ficam pendentes e só passam a efetivas depois de validadas pela equipa STREAM, que as pode aplicar ou descartar.",
      placement: "bottom",
    },
  ],
  sheet: [
    {
      target: ".tour-project-tab-sheet",
      title: "Tab Sheets",
      content:
        "Nesta área atualiza as horas de cada técnico afeto ao projeto, incluindo atividades do projeto e outras atividades.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-tech-selector",
      title: "Selecionar Técnico",
      content:
        "Escolha o técnico para editar a sheet. Se surgir a mensagem sem atividades no período, deve selecionar outro técnico ou ajustar o período.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-type-selector",
      title: "Tipo de Sheet",
      content:
        "Real: para alterar horas reais do projeto. Outras Atividades: para registar horas de outros projetos não listados na sheet e fora da gestão da STREAM.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-line-filter",
      title: "Filtro de Linhas",
      content:
        "Aqui controla a visibilidade das linhas da sheet: salários (quando aplicável), outros projetos e atividades/WPs.",
      placement: "bottom",
    },
    {
      target: ".tour-client-filter-btn",
      title: "Filtro de Período",
      content:
        "Este filtro define o período visível da sheet e também do resumo global do projeto.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-main-table",
      title: "Sheet Real",
      content:
        "Aqui edita horas e consulta dados de suporte como jornada diária, dias úteis, férias e restantes colunas da folha.",
      placement: "top",
    },
    {
      target: ".tour-sheet-summary",
      title: "Resumo da Sheet",
      content:
        "O resumo da sheet atualiza com as alterações, mostrando o impacto no técnico e no projeto conforme o agrupamento escolhido.",
      placement: "top",
    },
    {
      target: ".tour-client-save-btn",
      title: "Guardar Alterações",
      content:
        "As alterações só são persistidas quando carrega em Guardar. Se sair da página sem guardar, as alterações são perdidas.",
      placement: "bottom",
    },
  ],
  kpi: [
    {
      target: ".tour-project-tab-kpi",
      title: "Tab Resumo",
      content:
        "Esta tab apresenta o resumo global do projeto ao nível de custo, incentivo e ETI.",
      placement: "bottom",
    },
    {
      target: ".tour-summary-kpis",
      title: "KPIs Globais",
      content:
        "Os KPIs mostram executado, perspetivado e total do projeto no período e no total do projeto.",
      placement: "bottom",
    },
    {
      target: ".tour-summary-config",
      title: "Configuração de Visualização",
      content:
        "Aqui define dados, organização, subtotais e filtros por incluir/excluir para analisar o resumo como precisar.",
      placement: "bottom",
    },
    {
      target: ".tour-summary-table",
      title: "Tabela de Resumo",
      content:
        "A tabela apresenta o resumo global conforme a configuração e filtros aplicados acima.",
      placement: "top",
    },
  ],
};

const SHEET_TOUR_BRANCHES = {
  requiresTechnician: [
    {
      target: ".tour-sheet-tech-selector",
      title: "Selecionar Técnico",
      content: "Selecione um técnico para continuar o tutorial da sheet.",
      placement: "bottom",
    },
  ],
  realWithData: (isTheoretical) => [
    {
      target: ".tour-sheet-type-selector",
      title: "Tipo de Sheet",
      content: isTheoretical
        ? "Planeado: este projeto está em fase Teórica, por isso ainda não há execução real — as horas que edita aqui são o planeamento, e ficam também gravadas como Real automaticamente (não há divergência entre os dois enquanto o projeto for Teórico). Outras Atividades: para registar horas de outros projetos não listados na sheet e fora da gestão da STREAM."
        : "Real: para alterar horas reais do projeto. Outras Atividades: para registar horas de outros projetos não listados na sheet e fora da gestão da STREAM.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-line-filter",
      title: "Filtro de Linhas",
      content: "Aqui controla o que fica visível na tabela da sheet.",
      placement: "bottom",
    },
    {
      target: ".tour-client-filter-btn",
      title: "Filtro de Período",
      content: "Define o período de meses visível na sheet.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-main-table",
      title: isTheoretical ? "Sheet Planeado" : "Sheet Real",
      content:
        "Aqui edita horas e consulta dados de suporte como jornada diária, dias úteis, férias e restantes colunas da folha.",
      placement: "top",
    },
    {
      target: ".tour-sheet-summary",
      title: "Resumo da Sheet",
      content:
        "O resumo da sheet atualiza com as alterações, mostrando o impacto no técnico e no projeto conforme o agrupamento escolhido.",
      placement: "top",
    },
    {
      target: ".tour-client-save-btn",
      title: "Guardar Alterações",
      content:
        "As alterações ficam pendentes de aprovação pela equipa de gestão até serem confirmadas — só depois de aprovadas passam a valores finais do projeto.",
      placement: "bottom",
    },
  ],
  realWithoutData: (isTheoretical) => [
    {
      target: ".tour-sheet-type-selector",
      title: "Tipo de Sheet",
      content: isTheoretical
        ? "Este projeto está em fase Teórica, por isso esta sheet mostra \"Planeado\" em vez de \"Real\" — ainda não há execução real distinta do planeamento. Selecione o tipo de sheet e depois ajuste o período/funcionário para visualizar dados."
        : "Selecione o tipo de sheet e depois ajuste o período/funcionário para visualizar dados.",
      placement: "bottom",
    },
  ],
  otherWithModal: [
    {
      target: ".tour-sheet-type-selector",
      title: "Tipo de Sheet",
      content:
        "Escolha Outras Atividades para registar horas de projetos não geridos pela STREAM.",
      placement: "bottom",
    },
    {
      target: ".tour-sheet-actions",
      title: "Ações",
      content:
        "Use o botão Editar para abrir o modal. Para continuar o tutorial, precisa de abrir o modal.",
      placement: "bottom",
    },
    {
      target: ".tour-other-activities-content",
      title: "Modal de Outras Atividades",
      content: "Neste modal gere projetos e atividades fora da gestão STREAM.",
      placement: "top",
    },
    {
      target: ".tour-other-activities-projects",
      title: "Projetos",
      content: "Aqui são registados os projetos do cliente.",
      placement: "top",
    },
    {
      target: ".tour-other-activities-activities",
      title: "Atividades",
      content:
        "Aqui são registadas as atividades dos projetos. A coluna 'Afeto' controla se o técnico tem horas nas atividades.",
      placement: "top",
    },
    {
      target: ".tour-other-activities-warning",
      title: "Aviso Importante",
      content:
        "Eliminar atividade ou projeto pode fazer perder horas de outros técnicos.",
      placement: "top",
    },
    {
      target: ".tour-other-activities-close",
      title: "Fechar Modal",
      content: "Feche o modal para regressar à sheet principal.",
      placement: "top",
    },
  ],
};

const resolveSheetBranch = (context = {}) => {
  const sheetType = String(context.sheetType || "");
  const isOther = sheetType.includes("other");
  const hasData = Boolean(
    context.hasVisibleMonths && context.hasActivitiesDetails,
  );
  const isTheoretical = Boolean(context.isTheoretical);

  if (!context.hasTechnician) return SHEET_TOUR_BRANCHES.requiresTechnician;
  if (isOther) {
    return SHEET_TOUR_BRANCHES.otherWithModal;
  }
  if (hasData) return SHEET_TOUR_BRANCHES.realWithData(isTheoretical);
  return SHEET_TOUR_BRANCHES.realWithoutData(isTheoretical);
};

export const getProjectTabTourSteps = ({
  tab,
  showSummaryTab = true,
  context = {},
}) => {
  if (tab === "kpi" && !showSummaryTab) return [];
  if (tab === "sheet") return resolveSheetBranch(context);
  if (tab === "activities") {
    return PROJECT_TOUR_STEPS_BY_TAB.activities(Boolean(context.isTheoretical));
  }
  return PROJECT_TOUR_STEPS_BY_TAB[tab] || [];
};
